{
  "id": 28,
  "location": "paris",
  "difficulty": "normal",
  "moves": 29,
  "kinds": 6,
  "goals": [
    { "type": "collect", "kind": "latte", "count": 36 }
  ],
  "stars": [3500, 4380],
  "board": [
    "# # # . . # # #",
    "# # . . . . # #",
    "# . . . . . . #",
    ". . . . . . . .",
    ". . . . . . . .",
    "# . . . . . . #",
    "# # . . . . # #",
    "# # # . . # # #"
  ],
  "calibration": { "runs": 1000, "winRate": 0.663, "movesLeft": 5.7, "closeLosses": 0.124, "target": 0.65 }
}
